import { render } from "./GlucoseCalendarView.vue?vue&type=template&id=16b43870&scoped=true"
import script from "./GlucoseCalendarView.vue?vue&type=script&lang=js"
export * from "./GlucoseCalendarView.vue?vue&type=script&lang=js"

import "./GlucoseCalendarView.vue?vue&type=style&index=0&id=16b43870&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b43870"]])

export default __exports__